import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React from 'react';
import { Menu } from 'semantic-ui-react';
import { DEFAULT_LINK_AS } from './Link.constants';
import BaseLink from '../../../../../../atoms/Link';
import { isExternalPage } from '../../../../../../services/pages';
import { ObjectPropsPropType } from '../../../../../../services/proptypes';
import { EVENT_CATEGORIES, EVENT_ACTIONS } from '../../../../../analytics/components/Event';
var defaultProps = {
  type: 'internal',
  url: '',
  slug: '',
  as: DEFAULT_LINK_AS,
  title: '',
  className: '',
  linkProps: {},
  menuItemProps: {},
  onClick: function onClick() {
    return null;
  }
};
export default function Link(_ref) {
  var type = _ref.type,
    url = _ref.url,
    slug = _ref.slug,
    as = _ref.as,
    title = _ref.title,
    className = _ref.className,
    linkProps = _ref.linkProps,
    onClick = _ref.onClick,
    menuItemProps = _ref.menuItemProps;
  var isExternal = isExternalPage(type);
  var baseLinkProps = _objectSpread({
    to: isExternal ? url : slug,
    linkAs: as,
    title: title,
    internal: !isExternal,
    className: className
  }, linkProps);
  return /*#__PURE__*/React.createElement(Menu.Item, _extends({
    link: true
  }, menuItemProps, {
    onClick: onClick,
    as: BaseLink
  }, baseLinkProps, {
    event: {
      category: EVENT_CATEGORIES.NAVIGATION_EVENT_CATEGORY,
      action: EVENT_ACTIONS.NAVIGATION_MENU_CLICK_EVENT_ACTION,
      label: title
    }
  }));
}
Link.defaultProps = defaultProps;